import { forwardRef } from 'react';
import { DateTimePicker } from '@mui/x-date-pickers';
import { useController, useFormContext } from 'react-hook-form';
import { ExportSchema } from './exportSchema';
import { isValid } from 'date-fns';

interface Props {
  onUpdateDateTimePicker?: (fromDate: Date | null) => void;
}

export const ExportDateTimePicker = forwardRef<HTMLDivElement, Props>(
  ({ onUpdateDateTimePicker }: Props, ref) => {
    const { control } = useFormContext<ExportSchema>();

    const fromDateController = useController({ name: 'fromDate', control });
    return (
      <DateTimePicker
        {...fromDateController.field}
        value={fromDateController.field.value ?? null}
        ampm={false}
        viewRenderers={{
          hours: null,
          minutes: null,
          seconds: null,
        }}
        maxDate={new Date()}
        ref={ref}
        onChange={(value) => {
          if (isValid(value) && onUpdateDateTimePicker) onUpdateDateTimePicker(value);
        }}
        slotProps={{
          field: {
            clearable: true,
            onClear: () => fromDateController.field.onChange(undefined),
          },
          textField: {
            size: 'small',
            sx: {
              minWidth: '240px',
              maxWidth: '240px',
            },
          },
        }}
      />
    );
  }
);

ExportDateTimePicker.displayName = 'ExportDateTimePicker';
